<template>
  <!--
    Colored pill that shows "N days without device". Color follows the escalation
    matrix scheme from smart_units/helper.js (substantial / moderate / critical).
    Pill is presentation-only — the Assign call-to-action is rendered separately
    (matches the green Inventory-page ButtonAssignDevice) so the two concerns sit
    in their own table columns and don't crowd each other.
  -->
  <span
    v-if="days !== null && days !== undefined"
    class="awaiting-device-days-pill"
    :style="{ background: bgColor, color: '#ffffff' }"
  >
    {{ label }}
  </span>
  <span v-else class="grey--text">—</span>
</template>

<script>
import { awaitingDaysSolidChipColor, daysWithoutDeviceLabel } from "./helper";

export default {
  name: "AwaitingDeviceDaysPill",
  props: {
    days: { type: Number, default: null },
  },
  computed: {
    bgColor() {
      return awaitingDaysSolidChipColor(this.days);
    },
    label() {
      return daysWithoutDeviceLabel(this.days);
    },
  },
};
</script>

<style scoped>
.awaiting-device-days-pill {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}
</style>
